import {useIsLargeAndUp} from '~/common/hooks/useMatchQuery';
import {CancelSheet} from './buttons/CancelSheet';
import {CopyShareableLink} from './buttons/CopyShareableLink';
import {EditSheet} from './buttons/EditSheet';
import {ExportList} from './buttons/ExportList';
import {MessageHistory} from './buttons/MessageHistory';
import {MessageVolunteersButton} from './buttons/MessageVolunteers';
import {PrintSheet} from './buttons/PrintSheet';
import {ViewSheet} from './buttons/ViewSheet';
import {OptionGroup} from './OptionGroup/OptionGroup';

export const OrganizerTools = () => {
  const isLargeAndUp = useIsLargeAndUp();

  return (
    <div className="sheet-options">
      <OptionGroup title="Sheet Management">
        {!isLargeAndUp && (
          <>
            <CopyShareableLink />
            <ViewSheet />
          </>
        )}
        <EditSheet />
      </OptionGroup>

      <OptionGroup title="Volunteer Management">
        <MessageVolunteersButton />
        <MessageHistory />
        <PrintSheet />
        <ExportList />
        <CancelSheet />
      </OptionGroup>
    </div>
  );
};
